import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Tools|Review Tool|Exam Comments|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ExamSecurity,
	portal: 'SP',
};

type LocNameStart = 'SPReviewToolExamComments';
export type SPReviewToolExamCommentsLocNames =
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}LabelSource`
	| `${LocNameStart}LabelSubject`
	| `${LocNameStart}LabelText`;

export const spReviewToolExamCommentsLocs: LocDefs<SPReviewToolExamCommentsLocNames> = {
	SPReviewToolExamCommentsTitleSection: {
		defaultValue: 'Comments',
		description: 'Section Title',
		displayPath: `${pathStart}Section Title`,
		displayType: 'Title',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.Title.CommentSection',
		...sharedProperties,
	},
	SPReviewToolExamCommentsLabelSource: {
		defaultValue: 'Source',
		description: 'Column heading for: Source.',
		displayPath: `${pathStart}Source`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.ColumnHeading.Source',
		...sharedProperties,
	},
	SPReviewToolExamCommentsLabelSubject: {
		defaultValue: 'Subject',
		description: 'Column heading for: Subject.',
		displayPath: `${pathStart}Subject`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.ColumnHeading.Subject',
		...sharedProperties,
	},
	SPReviewToolExamCommentsLabelText: {
		defaultValue: 'Text',
		description: 'Column heading for: Text.',
		displayPath: `${pathStart}Text`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.ColumnHeading.Text',
		...sharedProperties,
	},
};

export type SPReviewToolExamCommentsLocType = LocMap<SPReviewToolExamCommentsLocNames>;
